import type React from 'react';

import type { ThirdPartyLogoProps } from '@atlassian/logo-third-party/types';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { NounSubtypeKey } from '../../constants/filters/universal-type';
import { ProductKeys } from '../../constants/product-keys';

const GoogleDocs = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/google-docs" */ '@atlassian/logo-third-party/google-docs'
		).then((module) => module.GoogleDocsIcon),
	{ moduleId: '@atlassian/logo-third-party/google-docs' },
);
const GoogleSheets = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/google-sheets" */ '@atlassian/logo-third-party/google-sheets'
		).then((module) => module.GoogleSheetsIcon),
	{ moduleId: '@atlassian/logo-third-party/google-sheets' },
);
const GoogleSlides = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/google-slides" */ '@atlassian/logo-third-party/google-slides'
		).then((module) => module.GoogleSlidesIcon),
	{ moduleId: '@atlassian/logo-third-party/google-slides' },
);
const MicrosoftWord = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/microsoft-word" */ '@atlassian/logo-third-party/microsoft-word'
		).then((module) => module.MicrosoftWordIcon),
	{ moduleId: '@atlassian/logo-third-party/microsoft-word' },
);
const MicrosoftExcel = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/microsoft-excel" */ '@atlassian/logo-third-party/microsoft-excel'
		).then((module) => module.MicrosoftExcelIcon),
	{ moduleId: '@atlassian/logo-third-party/microsoft-excel' },
);
const MicrosoftPowerPoint = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/microsoft-power-point" */ '@atlassian/logo-third-party/microsoft-power-point'
		).then((module) => module.MicrosoftPowerPointIcon),
	{ moduleId: '@atlassian/logo-third-party/microsoft-power-point' },
);

/** Official app logos for the six supported result subtypes. */
export const getFileTypeBrandIcon = (
	product: string,
	subtype: string | null | undefined,
): React.ComponentType<ThirdPartyLogoProps> | null => {
	if (product === ProductKeys.GoogleDrive) {
		switch (subtype) {
			case NounSubtypeKey.Document:
				return GoogleDocs;
			case NounSubtypeKey.Spreadsheet:
				return GoogleSheets;
			case NounSubtypeKey.Presentation:
				return GoogleSlides;
		}
	}
	if (product === ProductKeys.Sharepoint) {
		switch (subtype) {
			case NounSubtypeKey.Document:
				return MicrosoftWord;
			case NounSubtypeKey.Spreadsheet:
				return MicrosoftExcel;
			case NounSubtypeKey.Presentation:
				return MicrosoftPowerPoint;
		}
	}
	return null;
};
